import { render, staticRenderFns } from "./EditUnionmember.vue?vue&type=template&id=4eac1fda&"
import script from "./EditUnionmember.vue?vue&type=script&lang=js&"
export * from "./EditUnionmember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports